import { render, staticRenderFns } from "./ListPropertiesToApprove.vue?vue&type=template&id=d107afd0&"
import script from "./ListPropertiesToApprove.vue?vue&type=script&lang=js&"
export * from "./ListPropertiesToApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports